import * as React from "react";

import { useNoteActions } from "./noteActions";
import { noteReducer } from "./noteReducer";
import { initialNoteState, NoteState } from "./noteState";
import { combineReducers, useRelodeReducer, logAction } from "../../";

export interface INoteContext {
    noteState: NoteState;
    noteActions: ReturnType<typeof useNoteActions>;
}
export const NoteContext = React.createContext<INoteContext | undefined>(
    undefined
);

// TODO combined reducer with logging - dfm 11.19.2020
export const NoteProvider = (props: { children?: React.ReactNode }) => {
    const [state, dispatch] = useRelodeReducer(
        noteReducer,
        initialNoteState,
        logAction
    );

    const noteActions = useNoteActions(dispatch);

    const value = React.useMemo(
        () => ({
            noteState: state,
            noteActions,
        }),
        [noteActions, state]
    ) as INoteContext;

    return (
        <NoteContext.Provider value={value} {...props}>
            {props.children}
        </NoteContext.Provider>
    );
};

export const useNote = () => {
    const context = React.useContext(NoteContext) as INoteContext;
    if (context === undefined) {
        throw new Error("useNote must be used within a NoteProvider");
    }

    return context;
};
